import React from 'react';
import styles from './index.module.less';

interface Props {
  property: any;
}

const PropertyName: React.FC<Props> = (props: Props) => {
  const { property } = props;

  return (
    <div className={styles.categoryItem}>
      <div className={styles.categoryName}>
        <span className={styles.title}>{property.title}</span>
        <span className={styles.count}>{property.count}</span>
      </div>
    </div>
  );
};

export default React.memo(PropertyName);
